import React, { createContext, useContext, useState } from "react";

interface SelectedCollection {
  uuid: string;
  name: string;
}

interface SelectedCollectionsContextType {
  selectedCollections: SelectedCollection[];
  setSelectedCollections: React.Dispatch<
    React.SetStateAction<SelectedCollection[]>
  >;
}

const SelectedCollectionsContext = createContext<
  SelectedCollectionsContextType | undefined
>(undefined);

export function SelectedCollectionsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [selectedCollections, setSelectedCollections] = useState<
    SelectedCollection[]
  >([]);

  return (
    <SelectedCollectionsContext.Provider
      value={{ selectedCollections, setSelectedCollections }}
    >
      {children}
    </SelectedCollectionsContext.Provider>
  );
}

export const useSelectedCollections = () => {
  const context = useContext(SelectedCollectionsContext);
  if (!context) {
    throw new Error(
      "useSelectedCollections must be used within a SelectedCollectionsProvider"
    );
  }
  return context;
};
